import React from 'react';
import linkify from 'linkify-it';
import { Box, Link } from '@chakra-ui/react';
import colors from 'theme/foundations/colors.style';

interface TextMessageProps {
  body: string;
  isLocalParticipant: boolean;
}

const addLinks: any = (text: string) => {
  const matches = linkify().match(text);
  if (!matches) return text;

  const results = [];
  let lastIndex = 0;

  matches.forEach((match, i) => {
    results.push(text.slice(lastIndex, match.index));
    results.push(
      <Link target="_blank" rel="noreferrer" href={match.url} key={i}>
        {match.text}
      </Link>
    );
    lastIndex = match.lastIndex;
  });

  results.push(text.slice(lastIndex, text.length));

  return results;
};

const TextMessage: React.FC<TextMessageProps> = ({
  body,
  isLocalParticipant,
}: TextMessageProps) => {
  return (
    <Box
      alignItems="center"
      backgroundColor={isLocalParticipant ? colors.blue[500] : colors.gray[700]}
      borderRadius={
        isLocalParticipant ? "10px 10px 0 10px" : "10px 10px 10px 0"
      }
      color={isLocalParticipant ? colors.black : colors.white}
      display="inline-flex"
      padding="0.5em 0.8em 0.6em"
      whiteSpace="pre-wrap"
      wordBreak="break-word"
    >
      <>{addLinks(body)}</>
    </Box>
  );
};

export default TextMessage;
